import MailOutlineIcon from "@mui/icons-material/MailOutline";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDownloadEmailTemplate } from "../../api/useDownloadEmailTemplate";
import { HCPSpecificMessage, PrintDoc } from "../../generate";

interface Props {
  client: string;
  hcp: HCPSpecificMessage;
  baseDocName?: string;
  prescID?: string;
  includePI: boolean;
  templateType: string;
  labelKey: string;
  includeAttachment?: boolean;
}

const EmailTemplateButton: React.FC<Props> = ({
  client,
  hcp,
  baseDocName,
  prescID,
  includePI,
  templateType,
  labelKey,
  includeAttachment,
}) => {
  const [t] = useTranslation();

  const printDoc: PrintDoc = {
    client,
    baseDocName,
    prescID,
    includePI,
    isResource: false,
    isPrint: false,
    emailTemplateType: templateType,
    includeAttachment: includeAttachment ?? true,
  };

  const { isLoading: isDownloading, mutateAsync: downloadEmailTemplate } = useDownloadEmailTemplate(printDoc, hcp);

  const buttonClasses = classNames("btn btn-primary w-full", {
    "opacity-50 cursor-disabled": isDownloading,
  });

  return (
    <button disabled={isDownloading} className={buttonClasses} onClick={() => downloadEmailTemplate()}>
      <MailOutlineIcon />
      <span>{isDownloading ? t("loading") : t(labelKey)}</span>
    </button>
  );
};

export default EmailTemplateButton;
